import Vue from 'vue';
import Vuex from "vuex";

Vue.use(Vuex);

import auth from "@/modules/auth/store";
import user from "@/modules/user/store";
import subscription from "@/modules/subscription/store";

export default new Vuex.Store({
    state :{
        sidebarShow: 'responsive',
        sidebarMinimize: false,
    },
    mutations :{
        SET(state, [variable, value]){
            state[variable] = value
        },
        TOGGLE_SIDEBAR_DESKTOP(state){
            const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
            state.sidebarShow = sidebarOpened ? false : 'responsive'
        },
        TOGGLE_SIDEBAR_MOBILE(state){
            const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
            state.sidebarShow = sidebarClosed ? true : 'responsive'
        },
    },
    actions:{
        

    },
    getters:{
        
    },
    modules: {
        auth,
        user,
        subscription,
    }
});